import React, { useState } from "react";
import CommonModal from "../CommonComponents/Modal/CommonModal";
import { Box, Autocomplete, TextField, Typography } from "@mui/material";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import ErrorPopUp from "../CommonComponents/PopUpCards/ErrorPopUp";
import CommonPopup from "../CommonComponents/PopUpCards/CommonPopup";
import { ReactComponent as SuccessIcon } from "../../../assets/Images/SuccessProjectIcon.svg";
import { addLeadsToWorkflowsAction } from "./Store/workflows.action";

const SelectWorkflowModal = ({ contactObj }) => {
  const {
    selectWorkflowModal,
    workflows,
    setSelectWorkflowModal,
    selectedContactsData,
    setSelectedContactsData,
    setSelectedRows,
    dispatch,
    fetchLeadsData,
    filterState,
    setFilterState,
  } = contactObj;

  const [selectedWorkflows, setSelectedWorkflows] = useState(null) as any;
  const [loading, setLoading] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorObj, setErrorObj] = useState({
    open: false,
    errorMsg: "",
  });

  const filledFilters = Object.fromEntries(
    Object.entries(filterState)?.filter(([key, value]: any) => {
      if (typeof value === "string") {
        return value.trim() !== "";
      }
      if (
        typeof value === "object" &&
        value?.from !== undefined &&
        value?.to !== undefined
      ) {
        return Boolean(value.from) || Boolean(value.to);
      }
      return false;
    })
  );

  const handleAddContacts = async () => {
    setLoading(true);

    const payload = {
      workFlowIds: selectedWorkflows?.map((w) => w.id) || [],
      ...(selectedContactsData?.length > 0
        ? { leadIds: selectedContactsData }
        : { filter: filledFilters }),
    };

    const res = await dispatch(addLeadsToWorkflowsAction(payload));

    if (res?.status !== 200) {
      setErrorObj({
        open: true,
        errorMsg: res?.msg,
      });
    } else {
      setSuccessPopup(true);
    }
    setTimeout(() => {
      setSelectWorkflowModal(false);
    }, 2000);
    setFilterState({
      firstName: "",
      lastName: "",
      phone: "",
      createdAt: {
        from: "",
        to: "",
      },
      updatedAt: {
        from: "",
        to: "",
      },
    });
    setSelectedWorkflows([]);
    setSelectedRows([]);
    setSelectedContactsData([]);
    setLoading(false);
    fetchLeadsData(false);
  };

  return (
    <CommonModal
      body={
        <Box display="flex" flexDirection="column" gap={2}>
          <Autocomplete
            multiple
            options={workflows || []}
            getOptionLabel={(option) => option?.name || "No name"}
            value={selectedWorkflows || []}
            onChange={(event, newValue) => setSelectedWorkflows(newValue)}
            renderOption={(props, option) => (
              <li
                style={{
                  fontSize: "11px",
                  padding: "8px 18px",
                }}
                {...props}
                key={`${option.id}`}
              >
                {option?.name || "No Workflow Name"}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Workflows"
                sx={{
                  ...commonStyles.inputField,
                  "& .MuiOutlinedInput-input": {
                    p: "12px 35px 12px 15px",
                  },
                  "& .MuiAutocomplete-input": {
                    padding: "11px 15px !important",
                  },
                }}
              />
            )}
            isOptionEqualToValue={(option, value) =>
              `${option.id}_${option.name}` === `${value.id}_${value.name}`
            }
          />

          {errorObj.open && (
            <ErrorPopUp
              show={errorObj.open}
              toggle={() =>
                setErrorObj((prev) => ({
                  ...prev,
                  open: false,
                  errorMsg: "",
                }))
              }
              heading={"Error"}
              message={errorObj?.errorMsg}
              spin={false}
            />
          )}

          {successPopup && (
            <CommonPopup
              message={"Lead Data Added Successfully"}
              show={successPopup}
              toggle={() => setSuccessPopup((prev) => !prev)}
              Icon={SuccessIcon}
              heading={"Lead Data Added"}
            />
          )}
        </Box>
      }
      handleSave={handleAddContacts}
      heading={`Attach Workflows`}
      show={selectWorkflowModal}
      size={600}
      toggle={() => {
        setSelectWorkflowModal(false);
      }}
      saveButtonText="Attach"
      spin={loading}
    />
  );
};

export default SelectWorkflowModal;
